import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'activeFilter',
    pure: false
})
export class ActiveFilter implements PipeTransform {
    transform(items: any[], includeInactive?: boolean): any[] {
        if (!items) { return []; }
        if (includeInactive) { return items; }

        return items.filter( item => {
            return item.isActive;
        });
    }
}
